import React, { ForwardedRef, forwardRef } from "react";
import classnames from "classnames";

import * as styles from "./VStack.scss";

export interface IVStackProps {
    className?: string;
    innerSpacing?: "sm" | "md" | "lg";
    children?: React.ReactNode;
}

export const VStack = forwardRef(function VStack(
    props: IVStackProps,
    ref: ForwardedRef<HTMLDivElement>,
) {
    const { className, innerSpacing, children } = props;
    return (
        <div
            ref={ref}
            className={classnames(
                styles.vstack,
                innerSpacing && styles[`inner-spacing-${innerSpacing}`],
                className,
            )}
        >
            {children}
        </div>
    );
});
